import React from "react";
import "./App.css";
import SmoothScroll from "./components/SmoothScroll";
import Header from "./components/Header";
import Hero from "./components/Hero";
import About from "./components/About";
import Services from "./components/Services";
import Support from "./components/Support";
import Assessments from "./components/Assessments";
import Programs from "./components/Programs";
import Consultation from "./components/Consultation";
import Contact from "./components/Contact";
import Footer from "./components/Footer";

export default function App() {
  return (
    <SmoothScroll>
      <div className="App relative min-h-screen bg-wg-cream text-wg-ink">
        <Header />
        <main>
          <Hero />
          <About />
          <Services />
          <Support />
          <Assessments />
          <Programs />
          <Consultation />
          <Contact />
        </main>
        <Footer />
      </div>
    </SmoothScroll>
  );
}
